import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import DashboardVendorMain from "../vendor";
import { Icon } from "@iconify/react";

function DashboardSidebarMain() {
  const location = useLocation();
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [mainOrdersOpen, setMainOrdersOpen] = useState(false);
  const [orderSub, setOrdersSub] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true); // State for sidebar toggle

  useEffect(() => {
    if (location.pathname.startsWith('/orders')) {
      setOrdersSub(true);
    } else {
      setOrdersSub(false);
    }
  }, [location.pathname]);

  const isActiveRoute = (route) => {
    return location.pathname === route;
  };

  const toggleSubmenu = () => {
    setSubmenuOpen(!submenuOpen);
  };

  const toggleMainOrders = () => {
    setMainOrdersOpen(!mainOrdersOpen);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <>
      {/* Hamburger Button */}
      <button
        onClick={toggleSidebar}
        style={{
          position: "fixed",
          top: "20px",
          left: sidebarOpen ? "270px" : "20px",
          zIndex: 10001,
          background: "linear-gradient(135deg, #0f7c49 0%, #187837 100%)",
          border: "none",
          borderRadius: "12px",
          width: "48px",
          height: "48px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 12px rgba(15, 124, 73, 0.3)",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          color: "#fff",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.05)";
          e.currentTarget.style.boxShadow = "0 6px 16px rgba(15, 124, 73, 0.4)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(15, 124, 73, 0.3)";
        }}
      >
        <Icon
          icon={sidebarOpen ? "material-symbols:close" : "material-symbols:menu"}
          style={{ fontSize: "28px" }}
        />
      </button>

      {/* Overlay */}
      {sidebarOpen && (
        <div
          onClick={toggleSidebar}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 9999,
            // backdropFilter: "blur(2px)",
            animation: "fadeIn 0.3s ease",
          }}
        />
      )}

      {/* Sidebar */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: sidebarOpen ? 0 : "-280px",
          width: "280px",
          height: "100vh",
          background: "linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)",
          overflowY: "auto",
          overflowX: "hidden",
          boxShadow: "4px 0 24px rgba(0, 0, 0, 0.12)",
          zIndex: 10000,
          padding: "0",
          transition: "left 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          borderRight: "1px solid rgba(0, 0, 0, 0.08)",
        }}
      >
        {/* Sidebar Header */}
        <div
          style={{
            padding: "30px 20px 20px",
            borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
            background: "linear-gradient(135deg, #0f7c49 0%, #187837 100%)",
          }}
        >
          <h3
            style={{
              color: "#fff",
              margin: "0",
              fontSize: "20px",
              fontWeight: "600",
              letterSpacing: "0.5px",
            }}
          >
            Admin Panel
          </h3>
          <p
            style={{
              color: "rgba(255, 255, 255, 0.8)",
              margin: "5px 0 0",
              fontSize: "13px",
            }}
          >
            Kerala Special
          </p>
        </div>

        {/* Navigation */}
        <div style={{ padding: "20px 0" }}>
          <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
            <NavItem href="/dash-vendor" isActive={isActiveRoute("/dash")} icon="mdi:domain">
              Dashboard
            </NavItem>
            <NavItem href="/dash-vendor" isActive={isActiveRoute("/dash-vendor")} icon="mdi:domain">
              Vendor
            </NavItem>
            <NavItem href="/admin-users" isActive={isActiveRoute("/admin-users")} icon="subway:admin-1">
              Admin Users
            </NavItem>
            <NavItem href="/user-analytics" isActive={isActiveRoute("/user-analytics")} icon="solar:user-id-bold">
              Analytics
            </NavItem>
            <NavItem href="/dash-product" isActive={isActiveRoute("/dash-product")} icon="solar:box-bold">
              Product
            </NavItem>
            <NavItem href="/dash-category" isActive={isActiveRoute("/dash-category")} icon="mdi:category">
              Category
            </NavItem>
            <NavItem href="/dash-sub-category" isActive={isActiveRoute("/dash-sub-category")} icon="carbon:category">
              Sub Category
            </NavItem>
            <NavItem href="/product-group" isActive={isActiveRoute("/product-group")} icon="mdi:category">
              Product Group
            </NavItem>

            {/* Orders with Submenu */}
            <li
              onClick={() => setOrdersSub(!orderSub)}
              style={{
                padding: "12px 20px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderLeft: orderSub ? "3px solid #187837" : "3px solid transparent",
                backgroundColor: orderSub ? "rgba(24, 120, 55, 0.08)" : "transparent",
              }}
              onMouseEnter={(e) => {
                if (!orderSub) e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.04)";
              }}
              onMouseLeave={(e) => {
                if (!orderSub) e.currentTarget.style.backgroundColor = "transparent";
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <Icon icon="carbon:ibm-data-product-exchange" style={{ fontSize: "20px", color: "#187837" }} />
                <span style={{ fontSize: "14px", fontWeight: orderSub ? "600" : "500", color: "#2c3e50" }}>
                  Orders
                </span>
              </div>
              <Icon
                icon={orderSub ? "mdi:chevron-up" : "mdi:chevron-down"}
                style={{ fontSize: "20px", color: "#687280" }}
              />
            </li>

            {orderSub && (
              <div style={{ backgroundColor: "rgba(24, 120, 55, 0.03)", paddingLeft: "16px" }}>
                <SubNavItem to="/orders" isActive={isActiveRoute("/orders")} icon="carbon:delivery-parcel">
                  All Orders
                </SubNavItem>
                <SubNavItem to="/orders-active" isActive={isActiveRoute("/orders-active")} icon="mdi:package-variant-closed-delivered">
                  Active Orders
                </SubNavItem>
                <SubNavItem to="/orders-pending" isActive={isActiveRoute("/orders-pending")} icon="ri:pass-pending-fill">
                  Pending Orders
                </SubNavItem>
                <SubNavItem to="/orders-cancelled" isActive={isActiveRoute("/orders-cancelled")} icon="material-symbols:cancel-presentation-rounded">
                  Cancelled Orders
                </SubNavItem>
                <SubNavItem to="/orders-history" isActive={isActiveRoute("/orders-history")} icon="material-symbols:deployed-code-history-rounded">
                  Order History
                </SubNavItem>
              </div>
            )}

            <NavItem href="/mail" isActive={isActiveRoute("/mail")} icon="fluent:mail-add-24-filled">
              Bulk Mail
            </NavItem>
            <NavItem href="/deals" isActive={isActiveRoute("/deals")} icon="fluent:calendar-day-24-filled">
              Deals of the day
            </NavItem>
            <NavItem href="/popular" isActive={isActiveRoute("/popular")} icon="icon-park-outline:trend-two">
              Popular Products
            </NavItem>
            <NavItem href="/top_selling" isActive={isActiveRoute("/top_selling")} icon="carbon:sales-ops">
              Top Selling
            </NavItem>
            <NavItem href="/trending" isActive={isActiveRoute("/trending")} icon="fluent:data-trending-24-filled">
              Trending
            </NavItem>
            <NavItem href="/recently" isActive={isActiveRoute("/recently")} icon="system-uicons:box-add">
              Recently Added
            </NavItem>
            <NavItem href="/top-rated" isActive={isActiveRoute("/top-rated")} icon="icon-park-solid:align-top-two">
              Top Rated
            </NavItem>
            <NavItem href="/tab1" isActive={isActiveRoute("/tab1")} icon="simple-icons:rubygems">
              Kerala Gems
            </NavItem>
            <NavItem href="/tab2" isActive={isActiveRoute("/tab2")} icon="mdi:file-find">
              Featured Finds
            </NavItem>
            <NavItem href="/tab3" isActive={isActiveRoute("/tab3")} icon="icon-park-solid:traditional-chinese-medicine">
              Ayurvedic Delight
            </NavItem>
            <NavItem href="/banner" isActive={isActiveRoute("/banner")} icon="carbon:sales-ops">
              Banner
            </NavItem>
            <NavItem href="/reviews" isActive={isActiveRoute("/reviews")} icon="carbon:review">
              Reviews
            </NavItem>
            <NavItem href="/coupons" isActive={isActiveRoute("/coupons")} icon="mdi:coupon">
              Coupons
            </NavItem>
            <NavItem href="/blogs" isActive={isActiveRoute("/blogs")} icon="fa6-brands:blogger">
              Blogs
            </NavItem>
            <NavItem href="/users-contactus" isActive={isActiveRoute("/users-contactus")} icon="mage:message-check-round-fill">
              Contact info
            </NavItem>
          </ul>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        /* Custom Scrollbar */
        div::-webkit-scrollbar {
          width: 6px;
        }

        div::-webkit-scrollbar-track {
          background: #f1f1f1;
        }

        div::-webkit-scrollbar-thumb {
          background: #187837;
          border-radius: 3px;
        }

        div::-webkit-scrollbar-thumb:hover {
          background: #0f7c49;
        }
      `}</style>
    </>
  );
}

// NavItem Component for regular navigation items
function NavItem({ href, isActive, icon, children }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <li style={{ margin: "4px 0" }}>
      <a
        href={href}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          padding: "12px 20px",
          textDecoration: "none",
          color: isActive ? "#187837" : "#2c3e50",
          backgroundColor: isActive ? "rgba(24, 120, 55, 0.08)" : isHovered ? "rgba(0, 0, 0, 0.04)" : "transparent",
          borderLeft: isActive ? "3px solid #187837" : "3px solid transparent",
          fontSize: "14px",
          fontWeight: isActive ? "600" : "500",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Icon icon={icon} style={{ fontSize: "20px", color: isActive ? "#187837" : "#687280" }} />
        <span>{children}</span>
      </a>
    </li>
  );
}

// SubNavItem Component for submenu items
function SubNavItem({ to, isActive, icon, children }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <li style={{ margin: "2px 0" }}>
      <Link
        to={to}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          padding: "10px 20px 10px 36px",
          textDecoration: "none",
          color: isActive ? "#187837" : "#5a6c7d",
          backgroundColor: isActive ? "rgba(24, 120, 55, 0.12)" : isHovered ? "rgba(24, 120, 55, 0.06)" : "transparent",
          fontSize: "13px",
          fontWeight: isActive ? "600" : "500",
          transition: "all 0.2s ease",
          borderRadius: "0 8px 8px 0",
          marginRight: "12px",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Icon icon={icon} style={{ fontSize: "18px", color: isActive ? "#187837" : "#8895a7" }} />
        <span>{children}</span>
      </Link>
    </li>
  );
}

export default DashboardSidebarMain;
